import { Component, OnInit } from '@angular/core';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { RuleInterface } from '@vendasta/automata';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'automata-get-connection-data-vendor-panel',
  imports: [CommonModule, TranslateModule, FormsModule, GalaxyFormFieldModule, ReactiveFormsModule, MatInputModule],
  templateUrl: './get-connection-data-vendor-panel.component.html',
  styleUrl: './get-connection-data-vendor-panel.component.scss',
})
export class GetConnectionDataVendorPanelComponent extends CommonActionPanelComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.savingEnabled = true;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): any {
    return {};
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  isFormValid(): boolean {
    return true;
  }
}
